module.exports = {
  name: 'Síntesis',
  desc: 'Televisa - sintesis',
  prefix: 'boss',
  footerText: 'Televisa sintesis | Todos los derechos reservados 2018',
  logoText: 'Sintesis',
  needLogin: false
};

